exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tooltips {\n  position: absolute;\n  right: 0;\n  top: 20%;\n  display: none;\n}\n.tooltips .closetips {\n  position: absolute;\n}\n.tooltips .tipbody {\n  border: 1px #EAE7DA solid;\n  padding: 5px 0;\n  font-size: 12px;\n  width: 200px;\n  background-color: #ffffff;\n  color: #606060;\n  position: absolute;\n  right: 55px;\n  top: 66px;\n}\n.tooltips .tipbody .tips {\n  display: block;\n  margin: 0 14px;\n}\n.tooltips .tipbody .title {\n  display: block;\n}\n.tooltips .tipbody .title:before {\n  content: \"\";\n  padding: 3px;\n}\n.tooltips .tipbody .content {\n  display: block;\n  margin: 0 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/css_modules/tooltips.less
// module id = 454
// module chunks = 0